import React, { Component } from "react"
import FormField from "../FormField"
import { InputNumber } from "formik-antd"

export default class Followers extends Component {
  render() {
    return (
      <FormField name={this.props.name || "metadata.followers"} label="Total Followers">
        <InputNumber
          data-cy="account-followers"
          style={{ width: "100%" }}
          size="large"
          placeholder="1000"
        />
      </FormField>
    )
  }
}
